import { DocumentReceiptEntity } from '../../../generated-api';

type PayeeColumnProps = {
  record: DocumentReceiptEntity;
};
export function PayeeColumn({ record }: PayeeColumnProps) {
  if (record.payee) {
    return <>{record.payee[0]}</>;
  }
  return <>-</>;
}
